import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import styled from "styled-components";
import { useJoinMutation } from "../../../../api/account";
import { useGetAgentInfoMutation } from "../../../../api/agent";
import { requestVerifyCode, verifyCode } from "../../../../api/axiosApi";
import { modalSelector, useAppDispatch, useAppSelector } from "../../../../store";
import { setAgentInformationModal, setAlertModal, setLoadingModal } from "../../../../store/slice/modal";

const JoinPage = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin: 0 auto;

  width: 100%;
  min-height: calc(100vh - 84px);
  background-color: #f6f6f6;

  @media screen and (min-width: 1500px) {
    min-height: calc(100vh - 94px);
  }
`;

const JoinPageDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  width: 100%;

  .container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    flex-wrap: wrap;
    width: 440px;
    background-color: #fff;
    margin-top: 48px;

    padding: 30px 20px;
    margin: 20px 0 0;

    @media screen and (max-width: 440px) {
      width: 100%;
    }
  }

  .lawyer-Join {
    font-size: 16px;
    font-weight: 400;
    color: #242526;
    letter-spacing: 0px;
    line-height: 24px;
    text-align: center;
  }
`;

const JoinTitle = styled.h2`
  font-size: 24px;
  font-weight: 700;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #242526;
  letter-spacing: 0px;
  line-height: 34px;
  white-space: pre-line;
  text-align: center;
  margin-bottom: 32px;
`;

const JoinInputBox = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  margin-bottom: 16px;

  label {
    font-size: 14px;
    font-weight: 500;
    color: #28282d;
    letter-spacing: 0px;
    line-height: 20px;
    display: block;
    margin-bottom: 8px;
  }

  input {
    font-size: 16px;
    font-weight: 400;
    color: #3b3b42;
    letter-spacing: 0px;
    line-height: 20px;
    display: flex;
    align-items: center;
    width: 100%;
    height: 46px;
    border: 1px solid #a2b4ad;
    padding: 0 18px;
  }
`;

const JoinPolicyBox = styled.div`
  width: 100%;
  padding: 14px 16px;
  border: 1px solid #f1f3f5;
  background-color: #f8f9fa;
  margin-top: 28px;
`;

const PolicyAllCheckBox = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 6px;

  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    margin: 4px;
    margin-right: 8px;
  }

  label {
    font-size: 14px;
    font-weight: 700;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #212529;
    letter-spacing: 0px;
    line-height: 20px;
  }
`;

const PolicyCheckBox = styled.ul`
  list-style: none;
  li {
    display: flex;
    align-items: center;
    padding-left: 20px;
    margin-bottom: 6px;
    user-select: none;

    input[type="checkbox"] {
      width: 16px;
      height: 16px;
      margin: 4px;
      margin-right: 8px;
    }

    label {
      font-size: 14px;
      font-weight: 400;
      color: #212529;
      letter-spacing: 0px;
      line-height: 20px;
    }
  }
`;

const WarningMessage = styled.span`
  font-size: 12px;
  font-weight: 400;
  color: #ff0000;
  letter-spacing: 0px;
  line-height: 20px;
  display: block;
  margin-top: 7px;
`;

const JoinLinkBox = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  margin-top: 12px;

  a {
    font-weight: 700;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #89898e;
    letter-spacing: 0px;
    line-height: 24px;
    margin-right: 0;
    font-size: 15px;
    text-decoration: underline;
  }
`;

const JoinButton = styled.button`
  font-size: 16px;
  font-weight: 700;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
  letter-spacing: 0px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  height: 52px;
  background-color: #202d90;
  margin-top: 12px;

  &.disabled {
    background-color: #adb5bd;
  }
`;

const CheckInformationBtn = styled.button`
  font-size: 16px;
  font-weight: 700;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
  letter-spacing: 0px;
  line-height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  height: 52px;
  background-color: #202d90;
  margin-top: 12px;
  margin-bottom: 24px;

  &.disabled {
    background-color: #adb5bd;
  }

`;

const Contents = () => {
  const navigate = useNavigate();
  const [joinAPI] = useJoinMutation();
  const requiredPolicy = ["policy1", "policy2", "policy3"];
  const policyList = requiredPolicy.concat(["policy4"]);
  const [isChecked, setChecked] = useState(false);

  const [duplicateCheck, setDuplicateCheck] = useState(false);
  const dispatch = useAppDispatch();
  const { agentInformation: modal } = useAppSelector(modalSelector);
  const [agentApi] = useGetAgentInfoMutation();

  const [isEmailVerify, setEmailVerify] = useState(false);
  const [isCodeSent, setIsCodeSent] = useState(false);

  const {
    register,
    handleSubmit,
    setError,
    getValues,
    setValue,
    formState: { errors },
  } = useForm();

  const join = (accountInfo) => {
    dispatch(
      setLoadingModal({
        modalState: true,
      })
    );
    joinAPI({
      ...accountInfo,
      roles: "attorney",
      agentNo: getValues("agentNo"),
      fromSite: "INDIP.KR",
    })
      .unwrap()
      .then(({ status }) => {
        if (status === "success") {
          dispatch(
            setAlertModal({
              modalState: true,
              modalData: { title: "Sign up as Attorney", message: "Sign up as Attorney successful." },
              callback: () => {
                navigate("/login");
              },
            })
          );
        } else {
          dispatch(
            setAlertModal({
              modalState: true,
              modalData: { title: "Sign up as Attorney", message: "Sign up as Attorney failed." },
            })
          );
        }
      })
      .then((err) => {
        if (err) console.log(`error:${err}`);
      }).finally(()=>{
        dispatch(
          setLoadingModal({
            modalState: false,
          })
        );
      });
  };

  const handleSelectAll = (e) => {
    if (e.currentTarget.checked) {
      policyList.map((policy) => setValue(`${policy}`, true));
      setChecked(true);
    } else {
      policyList.map((policy) => setValue(`${policy}`, false));
      setChecked(false);
    }
  };

  const handleSelect = (e) => {
    setValue(`${e.currentTarget.id}`, e.currentTarget.checked);
    if (e.currentTarget.checked) {
      const isAllValuesTrue = policyList.every((policy) => getValues(`${policy}`) === true);
      setValue(`policyAll`, isAllValuesTrue);
    } else {
      setValue(`policyAll`, false);
    }

    const isRequiredPolicy = requiredPolicy.every((policy) => getValues(`${policy}`) === true);
    setChecked(isRequiredPolicy);
  };

  const requestVerifyEmail = () => {
    console.log("requestVerifyEmail");
    const emailParam = getValues("accountKey");
    if (!emailParam) {
      alert("Please enter your email address.");
      return;
    }
    if (!emailParam.match(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)) {
      alert("Please enter a valid email address.");
      return;
    }
    setIsCodeSent(true);
    dispatch(
      setLoadingModal({
        modalState: true,
      })
    );
    requestVerifyCode(emailParam, 0).then((res) => {
      if(res.data.status === "success") {
        alert("Verification code has been sent to your email.");
      } else {
        if(res.data.reason === "AlreadyAccountExist"){
          alert("This email is already registered.");
        } else {
          alert("Failed to send verification code to email.\nPlease try again later.");
        }
        setIsCodeSent(false);
      }
    }).catch((err) => {
      setIsCodeSent(false);
      alert("Failed to send verification code to email.\nPlease try again later.");
      console.log(err);
    }).finally(()=>{
      dispatch(
        setLoadingModal({
          modalState: false,
        })
      );
    });
  }

  const confirmCode = () => {
    console.log("confirmCode");
    const emailParam = getValues("accountKey");
    const codeParam = document.getElementById("email_check").value;
    dispatch(
      setLoadingModal({
        modalState: true,
      })
    );
    verifyCode({email: emailParam, code: codeParam}).then((res) => {
      if(res.data.status === "success") {
        alert("Verification code has been sent to your email.");
        setEmailVerify(true);
      } else {
        alert("Verification code does not match.");
      }
    }).catch((err) => {
      alert("Failed to verify email.\nPlease try again later.");
      console.log(err);
    }).finally(()=>{
      dispatch(
        setLoadingModal({
          modalState: false,
        })
      );
    });
  }


  const onSubmit = (data) => {
    console.log("onSubmit");
    if (!duplicateCheck) {
      dispatch(
        setAlertModal({
          modalState: true,
          modalData: { title: "Sign up as Attorney", message: "Please check your attorney number." },
        })
      );
      return;
    }
    if (getValues("password") !== getValues("password_check")) {
      setError(
        "password_check",
        {
          message: "Passwords do not match.",
        },
        { shouldFocus: true }
      );
      return;
    }
    if(!isEmailVerify) {
      alert("Please verify your email address before proceeding.");
      return;
    }

    try {
      join(data);
    } catch (error) {}
  };

  const setAgentInfo = (setFg, agentInfo) => {
    if (setFg) {
      setValue("agentNo", agentInfo.agentNo);
      setValue("mainArea", agentInfo.mainArea);
      setValue("subArea1", agentInfo.subArea1);
      setValue("subArea2", agentInfo.subArea2);
      setValue("subArea3", agentInfo.subArea3);
    }

    alert(`Agent information has been selected. Please verify that your information is correct.
      Name : ${agentInfo.name}
      Birth Year : ${agentInfo.birth}
      Qualification : ${agentInfo.qualification}
      Office Name : ${agentInfo.officeName}
      Business Status : ${agentInfo.businessStatus}
      Agent Number : ${agentInfo.agentNo}
      Main Area : ${agentInfo.mainArea}
      Sub Area 1 : ${agentInfo.subArea1}
      Sub Area 2 : ${agentInfo.subArea2}
      Sub Area 3 : ${agentInfo.subArea3}
    `);
  };

  const checkByAgentName = () => {
    dispatch(
      setLoadingModal({
        modalState: true,
      })
    );
    agentApi(`agentName/${getValues("humanName")}`)
      .unwrap()
      .then(({ status, data: agentInfo }) => {
        if (status === "success") {
          if (agentInfo === null || agentInfo.length === 0) {
            dispatch(
              setAlertModal({
                modalState: true,
                modalData: { title: "Agent Information", message: "No agent information found." },
              })
            );
            return;
          }

          if (agentInfo.length == 1) {
            setAgentInfo(true, agentInfo[0]);

            return;
          }

          if (agentInfo.length > 1) {
            dispatch(
              setAgentInformationModal({
                modalState: true,
                modalData: { title: "Agent Information", message: "Multiple agent information found.", agentList: agentInfo },
              })
            );
            return;
          }
        } else {
          dispatch(
            setAlertModal({
              modalState: true,
              modalData: { title: "Agent Information", message: "Failed to retrieve agent information." },
            })
          );
        }
      })
      .then((err) => {
        if (err) console.log(`error:${err}`);
      }).finally(()=>{
        dispatch(
          setLoadingModal({
            modalState: false,
          })
        );
      });
  };

  useEffect(() => {
    return () => {
      dispatch(setAgentInformationModal({ modalState: false, modalData: null }));
    };
  }, []);

  useEffect(() => {
    if (modal?.modalData?.selectedAgent) {
      const selected = modal?.modalData?.selectedAgent;
      setAgentInfo(true, selected);
    }
  }, [modal?.modalData?.selectedAgent]);

  const checkByAgentNo = () => {
    dispatch(
      setLoadingModal({
        modalState: true,
      })
    );
    agentApi(`agentNo/${getValues("agentNo")}`)
      .unwrap()
      .then(({ status, data: agentInfo }) => {
        if (status === "success") {
          if (agentInfo === null || agentInfo.length === 0) {
            setDuplicateCheck(false);
            dispatch(
              setAlertModal({
                modalState: true,
                modalData: { title: "Agent Information", message: "No agent information found." },
              })
            );
            return;
          }

          if (agentInfo.length === 1) {
            if (agentInfo[0].name !== getValues("humanName")) {
              setDuplicateCheck(false);
              dispatch(
                setAlertModal({
                  modalState: true,
                  modalData: { title: "Agent Number", message: "Agent number and name do not match." },
                })
              );
              return;
            }

            setDuplicateCheck(true);
            setAgentInfo(false, agentInfo[0]);

            return;
          }
        } else {
          setDuplicateCheck(false);
          if (agentInfo.message === "이미 등록된 변리사입니다.") {
            dispatch(
              setAlertModal({
                modalState: true,
                modalData: { title: "Agent Number", message: "This agent is already registered.\nPlease contact the administrator." },
              })
            );
            return;
          }

          dispatch(
            setAlertModal({
              modalState: true,
              modalData: { title: "Agent Information", message: "Failed to retrieve agent information." },
            })
          );
        }
      })
      .then((err) => {
        if (err) console.log(`error:${err}`);
      }).finally(()=>{
        dispatch(
          setLoadingModal({
            modalState: false,
          })
        );
      });
  };

  return (
    <main>
      <section>
        <form onSubmit={handleSubmit(onSubmit)}>
          <JoinPage>
            <JoinPageDiv>
              <div className="container">
                <JoinTitle>Sign up as Attorney</JoinTitle>
                <JoinInputBox>
                  <label htmlFor="email">Email</label>
                  <input
                    type="email"
                    id="email"
                    placeholder="Email ID"
                    disabled={isEmailVerify}
                    {...register("accountKey", {
                      required: "Please enter your email.",
                      pattern: {
                        value: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
                        message: "Please enter a valid email address.",
                      },
                    })}
                  />
                  <CheckInformationBtn type="button" disabled={isCodeSent} className={isCodeSent && "disabled"} onClick={requestVerifyEmail}>Send Verification Code</CheckInformationBtn>
                  {errors?.accountKey && <WarningMessage>{errors.accountKey.message}</WarningMessage>}
                </JoinInputBox>

                <JoinInputBox>
                  <label htmlFor="email">Email Verification Code</label>
                  <input
                    type="text"
                    id="email_check"
                    placeholder="Verification Code"
                    disabled={isEmailVerify}
                  />
                  <CheckInformationBtn type="button" disabled={isEmailVerify} className={isEmailVerify && "disabled"} onClick={confirmCode}>Confirm Verification Code</CheckInformationBtn>
                </JoinInputBox>

                <JoinInputBox>
                  <label htmlFor="humanName">Name</label>
                  <input
                    type="text"
                    id="humanName"
                    placeholder="User Name"
                    readOnly={duplicateCheck}
                    maxLength={10}
                    {...register("humanName", {
                      required: "Please enter your name.",
                    })}
                  />
                  {errors?.humanName && <WarningMessage>{errors.humanName.message}</WarningMessage>}
                </JoinInputBox>
                <CheckInformationBtn type="button" onClick={checkByAgentName}>
                  Confirm Agent Number by Name
                </CheckInformationBtn>
                <JoinInputBox>
                  <label htmlFor="password">Password</label>
                  <input
                    type="password"
                    id="password"
                    placeholder="Password"
                    {...register("password", {
                      required: "Please enter your password.",
                      pattern: {
                        value: /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&+-^])[A-Za-z\d@$!%*#?&+-^]{8,}$/,
                        message: "Password must be at least 8 characters long and include letters, numbers, and special characters.",
                      },
                    })}
                    autoComplete="off"
                  />
                  {errors?.password && <WarningMessage>{errors.password.message}</WarningMessage>}
                </JoinInputBox>
                <JoinInputBox>
                  <label htmlFor="password_check">Confirm Password</label>
                  <input
                    type="password"
                    id="password_check"
                    placeholder="Confirm Password"
                    {...register("password_check")}
                    autoComplete="off"
                  />
                  {errors?.password_check && <WarningMessage>{errors.password_check.message}</WarningMessage>}
                </JoinInputBox>
                <JoinInputBox>
                  <label htmlFor="agentNo">Agent Number</label>
                  <input
                    type="text"
                    id="agentNo"
                    placeholder="Agent Number"
                    readOnly={duplicateCheck}
                    {...register("agentNo", {
                      required: "Please enter your agent number.",
                    })}
                  />
                </JoinInputBox>
                <CheckInformationBtn type="button" onClick={checkByAgentNo}>
                  Confirm Agent Number
                </CheckInformationBtn>
                <JoinInputBox>
                  <label htmlFor="mainArea">Main Area</label>
                  <input
                    type="text"
                    id="mainArea"
                    placeholder="Main Area"
                    {...register("mainArea", {
                      required: "Please enter your main area.",
                    })}
                  />
                </JoinInputBox>
                <JoinInputBox>
                  <label htmlFor="subArea1">Sub Area 1</label>
                  <input
                    type="text"
                    id="subArea1"
                    placeholder="Sub Area 1"
                    {...register("subArea1", {
                      required: "Please enter your sub area 1.",
                    })}
                  />
                </JoinInputBox>
                <JoinInputBox>
                  <label htmlFor="subArea2">Sub Area 2</label>
                  <input
                    type="text"
                    id="subArea2"
                    placeholder="Sub Area 2"
                    {...register("subArea2", {
                      required: "Please enter your sub area 2.",
                    })}
                  />
                </JoinInputBox>
                <JoinInputBox>
                  <label htmlFor="subArea3">Sub Area 3</label>
                  <input
                    type="text"
                    id="subArea3"
                    placeholder="Sub Area 3"
                    {...register("subArea3", {
                      required: "Please enter your sub area 3.",
                    })}
                  />
                </JoinInputBox>
                <JoinPolicyBox>
                  <PolicyAllCheckBox>
                    <input type="checkbox" id="policy" {...register("policyAll")} onChange={handleSelectAll} />
                    <label htmlFor="policy">Agree to all</label>
                  </PolicyAllCheckBox>
                  <PolicyCheckBox>
                    <li>
                      <input
                        type="checkbox"
                        id={policyList[0]}
                        {...register(`${policyList[0]}`, { required: "This field is required." })}
                        onChange={handleSelect}
                      />
                      <label htmlFor={policyList[0]}>[Required] Terms of Service Agreement</label>
                    </li>
                    <li>
                      <input
                        type="checkbox"
                        id={policyList[1]}
                        {...register(`${policyList[1]}`, { required: "This field is required." })}
                        onChange={handleSelect}
                      />
                      <label htmlFor={policyList[1]}>[Required] Personal Information Collection and Use Agreement</label>
                    </li>
                    <li>
                      <input
                        type="checkbox"
                        id={policyList[2]}
                        {...register(`${policyList[2]}`, { required: "This field is required." })}
                        onChange={handleSelect}
                      />
                      <label htmlFor={policyList[2]}>[Required] Age 14 or older</label>
                    </li>
                    <li>
                      <input
                        type="checkbox"
                        id={policyList[3]}
                        {...register(`${policyList[3]}`)}
                        onChange={handleSelect}
                      />
                      <label htmlFor={policyList[3]}>[Optional] Marketing Information Collection Agreement</label>
                    </li>
                  </PolicyCheckBox>
                  {policyList.some((policy) => errors[`${policy}`]) && (
                    <WarningMessage>
                      {errors[`${policyList.find((policy) => errors[`${policy}`])}`].message}
                    </WarningMessage>
                  )}
                </JoinPolicyBox>
                <JoinLinkBox>
                  <Link to={"/login"}>Already a member?</Link>
                </JoinLinkBox>
                {/* <JoinLinkBox>
                  <Link to={"/joinAttorney"}>Are you an attorney?</Link>
                </JoinLinkBox> */}
                <JoinButton type="submit" disabled={!isChecked} className={!isChecked && "disabled"}>
                  Sign Up
                </JoinButton>
              </div>
            </JoinPageDiv>
          </JoinPage>
        </form>
      </section>
    </main>
  );
};

export default Contents;
